export default __webpack_public_path__ + "static/media/od-b-right_s.387da77f.jpg";